import Configs from "../config"
import React from "react"
import { Navigate } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"

const Authmiddleware = props => {
  if (!secureLocalStorage.getItem("auth_token")) {
    return (
      <Navigate
        to={{
          pathname: `${Configs.appurl}login`,
          state: { from: props.location },
        }}
      />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}

export default Authmiddleware
